import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper gfu-layout-wrapper--narrow _py-6 js-main-content _flexcol _gap-8" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")
  const _component_base_text = _resolveComponent("base-text")
  const _component_processing_button = _resolveComponent("processing-button")
  const _component_base_hero = _resolveComponent("base-hero")
  const _component_pledge_manager_info_statistics_box = _resolveComponent("pledge-manager-info-statistics-box")
  const _component_pledge_manager_info_introduction_box = _resolveComponent("pledge-manager-info-introduction-box")
  const _component_pledge_manager_info_explanation_boxes = _resolveComponent("pledge-manager-info-explanation-boxes")
  const _component_pledge_manager_info_values = _resolveComponent("pledge-manager-info-values")
  const _component_pledge_manager_info_setup_steps = _resolveComponent("pledge-manager-info-setup-steps")
  const _component_pledge_manager_info_why_us = _resolveComponent("pledge-manager-info-why-us")
  const _component_pledge_manager_info_promo_banner_box = _resolveComponent("pledge-manager-info-promo-banner-box")
  const _component_pledge_manager_info_highlights_box = _resolveComponent("pledge-manager-info-highlights-box")
  const _component_pledge_manager_info_comparison = _resolveComponent("pledge-manager-info-comparison")
  const _component_pledge_manager_info_partners = _resolveComponent("pledge-manager-info-partners")
  const _component_pledge_manager_info_faq_section = _resolveComponent("pledge-manager-info-faq-section")
  const _component_pledge_manager_info_help_center_links_box = _resolveComponent("pledge-manager-info-help-center-links-box")
  const _component_pledge_manager_info_call_to_action_box = _resolveComponent("pledge-manager-info-call-to-action-box")
  const _component_base_view = _resolveComponent("base-view")

  return (_openBlock(), _createBlock(_component_base_view, null, {
    default: _withCtx(() => [
      _createVNode(_component_footer_navigation, {
        "current-page": _ctx.Resources.Layout.PledgeManagerLink
      }, null, 8 /* PROPS */, ["current-page"]),
      _createVNode(_component_base_hero, {
        title: _ctx.Resources.PledgeManager.HeroBannerTitle,
        type: "pledgeManager"
      }, {
        description: _withCtx(() => [
          _createVNode(_component_base_text, {
            as: "div",
            level: "b2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.HeroBannerDescription), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_processing_button, {
            theme: "accent",
            "is-processing": _ctx.isProcessing,
            class: "_mt-5",
            onClick: $options.onAction
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.PledgeManager.HeroBannerCtaButtonLabel), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["is-processing", "onClick"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["title"]),
      _createElementVNode("main", _hoisted_1, [
        _createVNode(_component_pledge_manager_info_statistics_box, { stats: $options.statistics }, null, 8 /* PROPS */, ["stats"]),
        _createVNode(_component_pledge_manager_info_introduction_box, { stages: $options.introductionStages }, null, 8 /* PROPS */, ["stages"]),
        _createVNode(_component_pledge_manager_info_explanation_boxes, { sections: $options.explanationSections }, null, 8 /* PROPS */, ["sections"]),
        _createVNode(_component_pledge_manager_info_values, { values: $options.pledgeManagerValues }, null, 8 /* PROPS */, ["values"]),
        _createVNode(_component_pledge_manager_info_setup_steps, {
          steps: $options.setupSteps,
          summary: $options.setupStepsSummary,
          "setup-steps-description": $options.setupStepsDescription
        }, null, 8 /* PROPS */, ["steps", "summary", "setup-steps-description"]),
        _createVNode(_component_pledge_manager_info_why_us, { sections: $options.whyUsSections }, null, 8 /* PROPS */, ["sections"]),
        _createVNode(_component_pledge_manager_info_promo_banner_box, {
          title: _ctx.Resources.PledgeManager.PromoBannerTitle,
          description: _ctx.Resources.PledgeManager.PromoBannerDescription,
          "button-label": _ctx.Resources.PledgeManager.PromoBannerButtonLabel,
          "is-processing": _ctx.isProcessing,
          "desktop-image-url": "/content/images/static/pledge-manager/banner-desk.png",
          "mobile-image-url": "/content/images/static/pledge-manager/banner-mob.png",
          onAction: $options.onAction
        }, null, 8 /* PROPS */, ["title", "description", "button-label", "is-processing", "onAction"]),
        _createVNode(_component_pledge_manager_info_highlights_box, {
          items: $options.controlHighlights,
          summary: _ctx.Resources.PledgeManager.SectionControlHighlightsSummary,
          "action-label": _ctx.Resources.PledgeManager.SectionControlHighlightsActionLabel,
          "action-url": _ctx.createCreatorAccountUrl
        }, null, 8 /* PROPS */, ["items", "summary", "action-label", "action-url"]),
        _createVNode(_component_pledge_manager_info_comparison, { rows: $options.comparisonRows }, null, 8 /* PROPS */, ["rows"]),
        _createVNode(_component_pledge_manager_info_partners, { items: $options.partnerLogos }, null, 8 /* PROPS */, ["items"]),
        _createVNode(_component_pledge_manager_info_faq_section, { items: $options.faqItems }, null, 8 /* PROPS */, ["items"]),
        _createVNode(_component_pledge_manager_info_help_center_links_box, {
          description: _ctx.Resources.PledgeManager.SectionHelpCenterDescription,
          links: $options.helpCenterLinks
        }, null, 8 /* PROPS */, ["description", "links"]),
        _createVNode(_component_pledge_manager_info_call_to_action_box, {
          title: _ctx.Resources.PledgeManager.CtaTitle,
          description: _ctx.Resources.PledgeManager.CtaDescription,
          "button-label": _ctx.Resources.PledgeManager.CtaButtonLabel,
          "is-processing": _ctx.isProcessing,
          onAction: $options.onAction
        }, null, 8 /* PROPS */, ["title", "description", "button-label", "is-processing", "onAction"])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}